import { firestoreService } from '@/data/services/firestoreService';
import { UserRemapper } from '../../remappers/user/userRemapper';
import type { UserEntity } from '@/domain/entities/user/userEntity';

/**
 * GetUserUseCase
 * 
 * Retrieves a user by ID from Firestore.
 * Uses UserRemapper to transform raw Firestore data to User entity.
 */
export class GetUserUseCase {
    async execute(userId: string): Promise<UserEntity | null> {
        const json = await firestoreService.getUser(userId);

        if (!json) {
            return null;
        }

        return UserRemapper.toEntity(json);
    }
}

export const getUserUseCase = new GetUserUseCase();
